export const tipoArchivoVisita = {
    FOTO_VIVIENDA: 41,
    CAPACITACION: 42,
    FIRMA: 43,
    DOCUMENTOS: 44,
    SONDA: 45,
    LABORATORIO: 46,
    ESTUDIO_COMPLEMENTARIO: 47,
    TROQUELES: 49,
}